import { useEffect, useMemo, useState } from "react";

export const WORLD_CLOCKS = [
  { code: "AMS", city: "Amsterdam", zone: "Europe/Amsterdam" },
  { code: "SHA", city: "Shanghai", zone: "Asia/Shanghai" },
  { code: "KHH", city: "Kaohsiung", zone: "Asia/Taipei" },
  { code: "BOM", city: "Mumbai", zone: "Asia/Kolkata" },
  { code: "DXB", city: "Dubai", zone: "Asia/Dubai" },
  { code: "HOU", city: "Houston", zone: "America/Chicago" },
];

export const formatWorldTime = (date, timeZone) => new Intl.DateTimeFormat("en-GB", {
  timeZone,
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
}).format(date);

export const WorldClockBar = ({ settings }) => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 30000);
    return () => window.clearInterval(timer);
  }, []);
  const clocks = useMemo(() => WORLD_CLOCKS.map(clock => ({ ...clock, time: formatWorldTime(now, clock.zone) })), [now]);

  return <div className="world-clock-bar" data-testid="global-sourcing-clock-bar">
    <div className="world-clock-inner">
      <strong data-testid="global-sourcing-label">GLOBAL SOURCING</strong>
      <div className="world-clock-scroll" data-testid="world-clocks-scroll">
        <div className="world-clock-list">{clocks.map(clock => <span className="world-clock" tabIndex={0} title={clock.city} aria-label={`${clock.city} ${clock.time}`} aria-describedby={`world-clock-city-${clock.code.toLowerCase()}`} key={clock.code} data-testid={`world-clock-${clock.code.toLowerCase()}`}>
          <span className="world-clock-code">{clock.code}</span><span id={`world-clock-city-${clock.code.toLowerCase()}`} className="world-clock-city" role="tooltip">{clock.city}</span><time>{clock.time}</time>
        </span>)}</div>
      </div>
      <div className="world-clock-settings" data-testid="header-settings-desktop">{settings}</div>
    </div>
  </div>;
};